import PropTypes from 'prop-types';

export const ORGANIZATIONS__CREATE = 'ORGANIZATIONS__CREATE';
export const ORGANIZATIONS__CONNECT_FACEBOOK = 'ORGANIZATIONS__CONNECT_FACEBOOK';
export const ORGANIZATIONS__CONNECT_GIFTBIT = 'ORGANIZATIONS__CONNECT_GIFTBIT';
export const ORGANIZATIONS__DELETE = 'ORGANIZATIONS__DELETE';
export const ORGANIZATIONS__DISCONNECT_FACEBOOK = 'ORGANIZATIONS__DISCONNECT_FACEBOOK';
export const ORGANIZATIONS__DISCONNECT_GIFTBIT = 'ORGANIZATIONS__DISCONNECT_GIFTBIT';

export const ORGANIZATIONS__FETCH = 'ORGANIZATIONS__FETCH';
export const ORGANIZATIONS__FETCH_ONE = 'ORGANIZATIONS__FETCH_ONE';

export const ORGANIZATIONS__FACEBOOK_STATUS__ON = 'ORGANIZATIONS__FACEBOOK_STATUS__ON';
export const ORGANIZATIONS__FACEBOOK_STATUS__OFF = 'ORGANIZATIONS__FACEBOOK_STATUS__OFF';
export const ORGANIZATIONS__FACEBOOK_STATUS__INVALID = 'ORGANIZATIONS__FACEBOOK_STATUS__INVALID';

export const ORGANIZATIONS__GIFTBIT_STATUS__EXPIRED = 'ORGANIZATIONS__GIFTBIT_STATUS__EXPIRED';
export const ORGANIZATIONS__GIFTBIT_STATUS__ON = 'ORGANIZATIONS__GIFTBIT_STATUS__ON';
export const ORGANIZATIONS__GIFTBIT_STATUS__OFF = 'ORGANIZATIONS__GIFTBIT_STATUS__OFF';
export const ORGANIZATIONS__GIFTBIT_STATUS__INVALID = 'ORGANIZATIONS__GIFTBIT_STATUS__INVALID';

export const ORGANIZATIONS__REMOVE_BG_IMAGE = 'ORGANIZATIONS__REMOVE_BG_IMAGE';
export const ORGANIZATIONS__REMOVE_LOGO = 'ORGANIZATIONS__REMOVE_LOGO';

export const ORGANIZATIONS__UPDATE = 'ORGANIZATIONS__UPDATE';
export const ORGANIZATIONS__UPDATE_FEATURE = 'ORGANIZATIONS__UPDATE_FEATURE';
export const ORGANIZATIONS__UPLOAD_LOGO = 'ORGANIZATIONS__UPLOAD_LOGO';
export const ORGANIZATIONS__FETCH_TWILIO_DATA = 'ORGANIZATIONS__FETCH_TWILIO_DATA';

export const ORGANIZATIONS__FEATURES_ARRAY = PropTypes.arrayOf(
  PropTypes.shape({
    displayName: PropTypes.string,
    isActive: PropTypes.bool,
    name: PropTypes.string,
  }),
);

export const ORGANIZATIONS__SHAPE_ITEM = PropTypes.shape({
  features: ORGANIZATIONS__FEATURES_ARRAY,
  id: PropTypes.string,
  logo: PropTypes.shape({
    id: PropTypes.string,
    originalUrl: PropTypes.string,
    smallUrl: PropTypes.string,
    largeUrl: PropTypes.string,
    type: PropTypes.string,
  }),
  memberCount: PropTypes.number,
  membership: PropTypes.shape({
    createdAt: PropTypes.number,
    firstName: PropTypes.string,
    id: PropTypes.string,
    lastName: PropTypes.string,
    organizationId: PropTypes.string,
    role: PropTypes.string,
    userId: PropTypes.string,
  }),
  name: PropTypes.string,
  researcherCount: PropTypes.number,
  surveyCount: PropTypes.number,
});

export const ORGANIZATIONS__SHAPE_ARRAY = PropTypes.arrayOf(ORGANIZATIONS__SHAPE_ITEM);
